import { readAsDataUrlAsync } from '@/composables/file-upload'

const THUMBNAIL_MIME_TYPE = 'image/webp'
const THUMBNAIL_QUALITY = 0.8
const PHOTO_MIME_TYPE = 'image/jpeg'
const PHOTO_QUALITY = 0.85
const SVG_MIME_TYPE = 'image/svg+xml'

const decodeImageAsync = async(blob) => {
  const objectUrl = URL.createObjectURL(blob)
  try {
    const image = new Image()
    image.src = objectUrl
    await image.decode()
    return image
  } finally {
    URL.revokeObjectURL(objectUrl)
  }
}

const scaledDataUrlAsync = async(blob, scaleOf, mimeType, quality) => {
  const image = await decodeImageAsync(blob)
  const scale = Math.min(1, scaleOf(image))
  const canvas = document.createElement('canvas')
  canvas.width = Math.round(image.naturalWidth * scale)
  canvas.height = Math.round(image.naturalHeight * scale)
  canvas.getContext('2d').drawImage(image, 0, 0, canvas.width, canvas.height)
  return canvas.toDataURL(mimeType, quality)
}

const resizeToDataUrlAsync = (blob, maxHeight) => scaledDataUrlAsync(blob, image => maxHeight / image.naturalHeight, THUMBNAIL_MIME_TYPE, THUMBNAIL_QUALITY)

export const toPhotoDataUrlAsync = (blob, maxSide) => scaledDataUrlAsync(blob, image => maxSide / Math.max(image.naturalWidth, image.naturalHeight), PHOTO_MIME_TYPE, PHOTO_QUALITY)

export const useImageThumbnail = () => {
  const toThumbnailDataUrlAsync = async(url, maxHeight) => {
    const response = await fetch(url)
    if (!response.ok) {
      throw new Error(`Image request failed with status ${response.status}`)
    }
    const blob = await response.blob()
    return blob.type === SVG_MIME_TYPE ? readAsDataUrlAsync(blob) : resizeToDataUrlAsync(blob, maxHeight)
  }

  return {
    toThumbnailDataUrlAsync,
  }
}
